import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildClientHistoryListRequest } from "./clientHistoryRequest";

const API_URL = config.API_URL;

const idempotencyKey = (values = {}, prefix = "client-chat") => {
  const supplied = values && values.idempotency_key;
  if (typeof supplied === "string" && supplied.trim()) return supplied.trim();
  const randomPart = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : Math.random().toString(36).slice(2);
  return `${prefix}-${Date.now()}-${randomPart}`;
};

const multipartHeaders = (key) => ({
  ...authHeader({ contentType: "multipart/form-data" }),
  "Idempotency-Key": key,
});

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const key = idempotencyKey(values);
  
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  if (!values || !values.idempotency_key) formData.append("idempotency_key", key);
  const action = "afterlogin/clientchat/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);

  return axios.post(API_URL + action, formData, { headers: multipartHeaders(key) });
};

// const update = (values) => {
//   const auth = store.getState().auth;
//   const auth_key = auth.user.auth_key;
//   const formData = new FormData();
//   for (let value in values) {
//     formData.append(value, values[value]);
//   }
//   const action = "afterlogin/clientchat/update/" + values.id;
//   formData.append("auth_key", auth_key);
//   formData.append("action", action);
//   formData.append("client_id", values.client_id);
//   return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
// };

const view = (values) => {
  const request = buildClientHistoryListRequest("afterlogin/clientchat/view", values || {});
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};


const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/clientchat/delete/${values.id}`;
  const key = idempotencyKey(values, "client-chat-delete");
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: { ...authHeader(), "Idempotency-Key": key } });
};

const clientchatApiController = {
  create,
  // update,
  view,
  deleted,
};
export default clientchatApiController;
